<template>
    <div class="na-form">
        <div v-if="post" class="left">

            <div class="dx-fieldset">
                <div class="dx-field">
                    <div class="dx-field-label">ID:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.TagId' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Name:</div>
                    <div class="dx-field-value">

                        <DxTextBox class="udc-field-required" v-model:value='post.TagName'>
                            <DxValidator name="Name">
                                <DxRequiredRule />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                    <!--<div class="udc-description">
            <div class="udc-field-required">*</div>-->
                    <!--<div class="udc-field-description">xxxx</div>-->
                    <!--</div>-->

                </div>
                <div class="dx-field" v-if="!post.Integrates">
                    <div class="dx-field-label">Tag ist integriert in:</div>
                    <div class="dx-field-value">
                        <DxSelectBox :search-enabled="true" displayExpr="TagName" :dataSource="tagsList" valueExpr="TagId" v-model:value="post.TagIntId">
                        </DxSelectBox>
                    </div>

                </div>
                <div class="na-buttons-row">

                    <div>
                        <DxButton text="Save"
                                  type="default"
                                  styling-mode="contained"
                                  @click="onSaveClick()"
                                  onmouseover="this.style.backgroundColor='#006db9'" />
                    </div>
                    <div>
                        <DxButton text="Delete"
                                  type="default"
                                  styling-mode="contained"
                                  @click="onDeleteClick()"
                                  onmouseover="this.style.backgroundColor='#006db9'" />
                    </div>
                    <div>
                        <DxButton text="Close"
                                  type="default"
                                  styling-mode="outlined"
                                  @click="onCloseClick()" />
                    </div>
                    <div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import { DxTextBox } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import {
        DxValidator,
        DxRequiredRule
    } from 'devextreme-vue/validator';

    import { confirm, alert } from "devextreme/ui/dialog";
    //import DxDropDownBox from 'devextreme-vue/drop-down-box';
    //import DxTreeView from 'devextreme-vue/tree-view';
    import '../assets/detailForm.less';
    import $ from 'jquery';
    const baseUri = "WebApi.asmx/api/tagService";
    export default {
        name: 'TagDetail',
        components: {
            DxValidator,
            DxRequiredRule,
            DxButton,
            DxTextBox,
            DxSelectBox
            //DxDropDownBox,
            //DxTreeView

        },
        data() {
            return {
                post: null,
                files: [],
                tagsList:[],
                //treeDataSource: null,
                //treeBoxValue: null,
                //treeViewRefName: 'tree-view',

            };
        },
        created: function () {
            axios
                .get(baseUri + '/GetDetail')
                .then(res => {
                    this.post = res.data.data;
                    this.tagsList = res.data.tagList;
                });
        


        },
        methods: {
            onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                var formData = new FormData()
                formData.append("data", JSON.stringify(this.post))
                axios
                    .post(baseUri + '/SaveDetail', formData)
                    .then(res => {
                        if (res.data.success) { notify(`The changes were saved successfully`); }
                        else { alert(`error: ${res.data.errorMessage}`) }

                    })

            },
            onDeleteClick() {
                let result = confirm("do you really want to delete this record?", "Confirm delete");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        var formData = new FormData()
                        formData.append("data", JSON.stringify(this.post))
                        axios
                            .post(baseUri + '/Delete', formData)
                            .then(res => {
                                if (res.data.success) {
                                    notify(`The record has been successfully deleted`);
                                    $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                                }
                                else { alert(`error: ${res.data.errorMessage}`) }

                            })
                    }


                });


            },
            onClick(e) {
                const buttonText = e.component.option('text');
                notify(`The ${this.capitalize(buttonText)} button was clicked`);
            },
            capitalize(text) {
                return text.charAt(0).toUpperCase() + text.slice(1);
            }
        }
    }


</script>
<style>
</style>
